(() => {
if(customElements.get('ck-pickup')) return;
let saved;
const key='Fecha solicitada de retiro', hourKey='Hora solicitada de retiro';
const nowLocal=()=>new Intl.DateTimeFormat('sv-SE',{timeZone:'America/Montevideo',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hour12:false}).format(new Date()).replace(' ','T');
class Pickup extends HTMLElement {
connectedCallback(){
 if(this.ready) return; this.ready=true;
 this.input=this.querySelector('input[type=date]'); this.time=this.querySelector('input[type=time]');this.status=this.querySelector('[data-status]');
 this.input.min=nowLocal().slice(0,10);
 if(saved){this.input.value=saved.date;this.time.value=saved.time;}
 this.updateLink();
 [this.input,this.time].forEach(input=>input.addEventListener('input',()=>{this.status.textContent='Guardá el día y la hora para incluirlos en tu pedido.';this.updateLink();}));
 this.querySelector('[data-save]').addEventListener('click',()=>this.save(false));
 this.querySelector('[data-clear]').addEventListener('click',()=>this.save(true));
}
updateLink(){
 let text='Hola, quisiera coordinar un retiro en Estivao 1571, Montevideo.';
 if(this.input.value){const [y,m,d]=this.input.value.split('-');text+=' El día '+d+'/'+m+'/'+y;}
 if(this.time.value) text+=' a las '+this.time.value+' (hora de Uruguay)';
 text+='. ¿Me confirman la coordinación?';
 this.querySelector('[data-whatsapp]').href='https://wa.me/59898013346?text='+encodeURIComponent(text);
}
async save(clear){
 this.input.min=nowLocal().slice(0,10);
 if(!clear){
 for(const input of [this.input,this.time]){input.required=true;if(!input.reportValidity()){input.required=false;return;}input.required=false;}
 if(this.input.value+'T'+this.time.value<=nowLocal()){this.status.textContent='Elegí un día y una hora futuros.';return;}
 }
 const value=clear?'':this.input.value, hour=clear?'':this.time.value;
 const controls=[...document.querySelectorAll('ck-pickup button,ck-pickup input')];controls.forEach(b=>b.disabled=true);
 this.status.textContent='Guardando…';
 try{
 const r=await fetch(window.Shopify.routes.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[key]:value,[hourKey]:hour}})});
 if(!r.ok)throw Error();
 const cart=await r.json();
 if((cart.attributes[key]||'')!==value||(cart.attributes[hourKey]||'')!==hour)throw Error();
 saved={date:value,time:hour};
 document.querySelectorAll('ck-pickup').forEach(el=>{el.input.value=value;el.time.value=hour;el.updateLink();el.status.textContent=value?'Día y hora guardados en tu pedido. Coordiná por WhatsApp antes de pasar.':'Selección eliminada.';});
 }catch(e){this.status.textContent='No pudimos guardar la selección. Intentá nuevamente antes de continuar.';}
 finally{controls.forEach(b=>b.disabled=false);}
}
}
customElements.define('ck-pickup',Pickup);
})();